import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import RaisedButton from 'material-ui/RaisedButton';
import Inputmask from 'inputmask';
import moment from 'moment';
import swal from 'sweetalert';
import ModalPlaces from './modalPlaces';
import {Table, Button} from 'react-bootstrap';
import {Typeahead} from 'react-bootstrap-typeahead';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';
import PhonesData from '../../offers/components/PhonesData';
import AddressData from '../../offers/components/AddressData';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import $ from 'jquery';

const Config = require('../../../config');

class RegisterCampaign extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.onSave = this.onSave.bind(this);
		this.addPlace = this.addPlace.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.deleteProduct = this.deleteProduct.bind(this);
		this.updateMedical = this.updateMedical.bind(this);
		this.addMedical = this.addMedical.bind(this);
		this.changeMedicalPersonal = this.changeMedicalPersonal.bind(this);
		this.savePerson = this.savePerson.bind(this);
		this.validateInput = this.validateInput.bind(this);
		//this.addPhone = this.addPhone.bind(this);

		this.state = {
			campaign:"",
			convoke_places:[],
			convoke_places_id:"",
			start_date:"",
			start_hour:"",
			end_date:"",
			end_hour:"",
			description:"",
			human_resources:"",
			material_resources:"",
			id:"",
			medical_staff:[],
			medical_staff_id:"",
			product:"",
			products:[],
			campaign_has_products:[],
			amount:"",
			index:-1,
			medicalSelected:[],

			index_personal:-1,
			medical_person_id:"",
			medical_list:[],
			medical_person_selected:[],

			lastname1:"",
			lastname2:"",
			name:"",
			email:"",
			street:"",
			ext_num:"",
			colonia:"",
			municipio:"",
			state:"",
			postal_code:"",
			document_type:"DOCUMENT_INE",
			document_number:"",
			documents:[],
			phonesAdded:[],

			list_person:[],

			phone_type:"CELULAR",
	        phone_number:"",
	        showCheckboxes: false,
	        ext:"",

	        phoneTypes:[],
	        errorText_phone_type:"",
	        errorText_phone_number:"",
	        task_list:"",
		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#start_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#end_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		var start = document.getElementById("start_hour");
		var im = new Inputmask("--:--");
		im.mask(start);

		var end = document.getElementById("end_hour");
		im.mask(end);

		this.getConvokePlace();

		fetch(Config.default.apiGateway.URL+'medical_staff',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.map((res)=>{
					res.names = res.medical_staff.lastname1+' '+
									(res.medical_staff.lastname2 !== null ? res.medical_staff.lastname2 : '')+' '+
									res.medical_staff.names
				})

				this.setState({medical_staff:response});

				if(this.props.match.params.id !== undefined){
					setTimeout(()=>{
						this.getValues();
					}, 500)
				}
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=PHONE_TYPE&notrender=0',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      this.setState({
	          phoneTypes: response
	        });
	    })

		fetch(Config.default.apiGateway.URL+'lookups?type=PROMOTION_PRODUCTS&option=actives&order=true',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({products:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      documents: response
		    });
		})
	}

	getValues(){
		fetch(Config.default.apiGateway.URL+'campaigns/'+this.props.match.params.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
	    }})
		.then(response => {
			if(response !== undefined){
				var index = this.state.medical_staff.findIndex(obj =>
					obj.medical_staff.id === response.campaigns.medical_staff_id
				)


				var medical = []

				if(response.campaign_has_medical_staff !== undefined){
					response.campaign_has_medical_staff.map((m)=>{
				    	var medical_index = this.state.medical_staff.findIndex(obj =>
							obj.medical_staff.id === m.medical_staff_id
						)
						if(medical_index !== -1){
							medical.push({
					    		medical_staff_id: m.medical_staff_id,
					    		id:m.id,
					    		title:this.state.medical_staff[medical_index].medical_staff.person_title,
					    		name:this.state.medical_staff[medical_index].names
					    	});
						}
				    })
				}
				    

				this.setState({
					campaign:response.campaigns.name,
					convoke_places_id:response.campaigns.convoke_places_id,
					start_date:moment(response.campaigns.start_date).format('YYYY-MM-DD'),
					start_hour:moment(response.campaigns.start_hour, 'H:mm:ss').format('HH:mm'),
					end_date:moment(response.campaigns.end_date).format('YYYY-MM-DD'),
					end_hour:moment(response.campaigns.end_hour, 'H:mm:ss').format('HH:mm'),
					description:response.campaigns.description,
					human_resources:response.campaigns.rrhh_list,
					material_resources:response.campaigns.rrm_list,
					id:response.campaigns.id,
					index: index,
					medicalSelected: index !== -1 ? [this.state.medical_staff[index]] : [],
					campaign_has_products:response.campaign_has_products,
					medical_staff_id: response.campaigns.medical_staff_id,
					task_list:response.campaigns.task_list,
					medical_list:medical,
			    });

				



			}
				

		});
	}

	getConvokePlace(){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=no_operatives&health_facilities_id='+
			sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
	    }})
		.then(response => {
			this.setState({
		      convoke_places: response
		    });
		});
	}

	validString(value){
		return new RegExp("^[a-zA-Záéíóú´ ./ñÑ]+$").test(value);
	}

	handleChange(e){

		if(e.target.name === 'name' || e.target.name === 'lastname1' || e.target.name === 'campaign'){
			if(e.target.value === ""){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
			if(this.validString(e.target.value)){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
		}else{
			this.setState({
				[e.target.name] : e.target.value
			});
		}

		if(e.target.name === 'start_hour' || e.target.name === 'end_hour'){
			this.validateHour(e.target);
		}else if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && e.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	validateHour(campo){
		var hour = moment(campo.value, 'h:mm a');

		if(hour.format('H:mm') === "Invalid date" || campo.value.indexOf('-') !== -1){
			document.getElementById(campo.id).classList.add("error");
			document.getElementById(campo.name).style.borderColor = "red";
		}else{
			document.getElementById(campo.name).style.borderColor = "#ccc";
			document.getElementById(campo.id).classList.remove("error");
		}
	}

	onReturn(e){
		e.preventDefault();

		this.props.history.push('/promotion/campaign');
	}

	onSave(){
		if(this.isValidForm('finales')){
			var method = 'post';
			var apiUrl = 'campaigns';
			var start_date = moment(this.state.start_date);
			var end_date = moment(this.state.end_date);
			
			var obj = {
				name:this.state.campaign,
				convoke_places_id:this.state.convoke_places_id,
				start_date:start_date === 'Invalid Date' ? '' : start_date.format('MM-DD-YYYY'),
				start_hour:this.state.start_hour.indexOf('-') !== -1 ? '' : moment(this.state.start_hour, 'HH:mm').format('H:mm'),
				end_date:end_date === 'Invalid Date' ? '' : end_date.format('MM-DD-YYYY'),
				end_hour:this.state.end_hour.indexOf('-') !== -1 ? '' : moment(this.state.end_hour, 'HH:mm').format('H:mm'),
				description:this.state.description,
				rrhh_list:this.state.human_resources,
				rrm_list:this.state.material_resources,
				medical_staff_id:this.state.medical_staff_id,
				task_list:this.state.task_list,
				campaign_has_products:this.state.campaign_has_products,
				campaign_has_medical_staff:[],
				campaign_has_contacts:[]
			}

			this.state.medical_list.map((m)=>{
				obj.campaign_has_medical_staff.push({
					medical_staff_id:m.medical_staff_id
				})
			})

			this.state.list_person.map((p)=>{
				obj.campaign_has_contacts.push({
					person_id: p.id
				})
			})

			if(this.state.id !== ""){
				obj.id = this.state.id;
				method = 'put';
				apiUrl = 'campaigns/'+this.state.id;
			}
			fetch(Config.default.apiGateway.URL+apiUrl,{
				method:method,
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					swal('Correcto', 'El registro se guardo correctamente', 'success');
					this.props.history.push('/promotion/campaign');
				}
			});
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}			
	}

	isValidForm(type) {
		var inputs = [];
		if(type === undefined){
			inputs = document.querySelectorAll('select,input');
		}else{
			const select = document.querySelector("div."+type);
	
			inputs = select.querySelectorAll('input, select');
		}
			
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
    			const isInputValid = this.showCtrlError(input.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	addPlace(){
		this.modal_places.handleShow();
	}

	updateMedical(values) {
	    if (values.length > 0) {
	    	var index = this.state.medical_staff.findIndex(obj =>
				obj.medical_staff.id === values[0].medical_staff.id
			)
					
	    	this.setState({
	    		medical_staff_id:values[0].medical_staff.id,
	    		index: index,
				medicalSelected: [this.state.medical_staff[index]],
    		});
	    }
	}

	addProduct(e){
		var products = this.state.campaign_has_products;

		var existe = products.findIndex(obj => 
			obj.product === this.state.product
		)

		if(existe === -1){
			var obj = {
				product:this.state.product,
				amount:this.state.amount
			}

			products.push(obj);

			this.setState({campaign_has_products:products, product:"", amount:""});
		}else{
			swal('Error', 'No es posible agregar el producto debido a que ya se encuentra en la tabla', 'error');
		}	
	}

	deleteProduct(e,i){
		var array = [...this.state.campaign_has_products];
		array.splice(i, 1);
		this.setState({campaign_has_products: array});
	}

	deleteMedical(e,i){
		var array = [...this.state.medical_list];
		array.splice(i, 1);
		this.setState({medical_list: array});
	}

	changeMedicalPersonal(values){
		if (values.length > 0) {
			var index = this.state.medical_staff.findIndex(obj =>
				obj.medical_staff.id === values[0].medical_staff.id
			)
					
	    	this.setState({
	    		medical_person_id:values[0].medical_staff.id,
	    		index_personal: index,
				medical_person_selected: [this.state.medical_staff[index]],
    		});
	    	//this.setState({medical_person_id:values[0].medical_staff.id});
	    }
	}

	addMedical(){

		var existe = this.state.medical_list.findIndex(obj => 
			obj.medical_staff_id === this.state.medical_person_selected[0].medical_staff.id
		)	
		
		if(existe === -1){
			this.setState({
				medical_list:[...this.state.medical_list, {
					medical_staff_id: this.state.medical_person_selected[0].medical_staff.id,
					title:this.state.medical_person_selected[0].medical_staff.person_title,
					name: this.state.medical_person_selected[0].names,
				}],
				medical_person_selected:[],
				index_personal:-1,
			});

			this._typeahead_medical.getInstance().clear();
		}else{
			swal('Error', 'No es posible agregar debido a que ya se encuentra en la tabla', 'error');
		}	
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});

		if(event.target.name === "donation_type_id"){
			if(this.state.patient_person_id === ""){
				if(this.patient !== undefined && this.patient !== null){
					
					setTimeout(()=>{
						if(this.patient!== null){
							this.patient.refs._handleSearch._instance.clear();	
						}
						
					}, 500);
					
				}
				this.clearPatientSearch();
			}
		}

		if(event.target.id !== null){
	        var control = document.getElementById(event.target.id);
	        if(control !== null){
	        	if(control.required){
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}else{
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}
	        }
	    }
	}

	/*addPhoneToList = (phone) => {
		
		this.setState({ phonesAdded: [...this.state.phonesAdded, phone]});
	}

	removePhoneFromList = (indice) => {
		
		var array = [...this.state.phonesAdded];
		array.splice(indice, 1);
		this.setState({phonesAdded: array});
		
	}*/

	savePerson(){
		if(this.isValidForm('person')){
			var obj = {
				person_type: 'CAMPAINGS',
				names:this.state.name,
				lastname1:this.state.lastname1,
				lastname2:this.state.lastname2,
				email:this.state.email,
				phones:[{
					type: this.state.phone_type,
              		number: this.state.phone_number
				}],
				documents:[{
					document_type:this.state.document_type,
					document_number:this.state.document_number
				}],
				address:{
					street:this.state.street,
					ext_num:"",
					municipio:this.state.mpio,
					estado:this.state.state,
					postal_code:this.state.postal_code
				}
			}

			fetch(Config.default.apiGateway.URL+'person',{
				method:'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						list_person:[...this.state.list_person, {
							id:response.id, 
							name: response.lastname1+' '+response.lastname2+' '+response.names,
							phone: response.phones.length > 0 ? response.phones[0].number : ""
						}]
					});
				}
			})


		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	/*addPhone() {

      if (this.isValidPhone()===true) {
        var flag = false;
          for (var i = 0; i < this.state.phonesAdded.length; i++) {
              if (this.state.phonesAdded[i].type === this.state.phone_type) {
                flag = true;
                break
              };
          };

          if (flag === true) {
            swal('¡El teléfono no se puede agregar!', '¡Ya se ingreso un número con ese tipo!', 'error');
          } else{
            var obj = {};
              obj.type = this.state.phone_type;
              obj.number = this.state.phone_number;
              obj.extension = this.state.ext;
            this.addPhoneToList(obj)
            this.setState({phone_number:""});
          }
      } else{
        swal('¡El teléfono no se puede agregar, tiene errores de validación!', '¡Los errores están marcados en rojo!', 'error');
      };
  	}*/
  	//Verificar si el formulario es valido
	isValidPhone() {
	    let isFormValid = true;
	      const isSelectValid4 = this.showControlErrorPhone('phone_number');
	      if ( !isSelectValid4 ) {
	        isFormValid = false;
	      } 
	      
	      return isFormValid;
	}

	//desplegar errores en selceted
	showControlErrorPhone(refName) {
	    var res = null;
	    var control = document.getElementById(refName);

	    if (this.state[refName] === null || this.state[refName] === "") {
	      control.classList.add('error');
	      res = false;
	    } else{
	      if(refName === "phone_number"){
	        if(this.state[refName].split('_').length!==1){
	          control.classList.add('error');
	          return false;
	        }
	      }
	      control.classList.remove('error');
	      res = true;
	    };

	    return res;
	}
	
	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					Promoción ->
					Registro
					</h5>
				</div>
				<div className="col-xs-12">
					<fieldset className="col-xs-12">
						<legend>Datos Generales</legend>

						<div className="finales">
							<div className="col-xs-12 form-group" style={{padding:"0px"}}>
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Nombre de Campaña</span>
									<input type="text" name="campaign" id="campaign" value={this.state.campaign}
										onChange={this.handleChange} className="form-control" required />
								</div>
								
								<div className="col-xs-12 col-sm-4">
									<div className="col-xs-12 col-sm-11" style={{padding:'0'}}>
										<span className="span-min">Lugar de Colecta</span>
										<select name="convoke_places_id" id="convoke_places_id" value={this.state.convoke_places_id}
											onChange={this.handleChange} className="form-control" required>
											<option value="">Seleccione...</option>
											{this.state.convoke_places.map((t, i) => (
												<option key={i}  value={t.convoke_places.id} >
													{t.convoke_places.name} 
												</option>
											))}
										</select>
									</div>
									<div className="col-xs-12 col-sm-1" style={{padding:'0', paddingLeft:'8px'}}>
										<FloatingActionButton className="action-btn" mini={true} 
											style={{marginTop: 20 }} onClick={this.addPlace} iconStyle={{height: 25, width: 25}}>
					                      <ContentAdd/>
					                    </FloatingActionButton> 
				                    </div>
								</div>
							</div>
							<div className="col-xs-12 form-group finales" style={{padding:"0px"}}>
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Responsable de Campaña</span>
									<Typeahead
								        labelKey={(option) => `${option.names}`}
								        minLength={0}
								        maxLength={50}
								        name="patient"
								        id="patient"
								        options={this.state.medical_staff}
								        onChange={this.updateMedical}
								        ref={ref => this._typeahead = ref}
								        useCache={false}
								        defaultSelected={this.state.medical_staff.slice(this.state.index, 1)}
										selected={this.state.medicalSelected}
										delay={600}
										paginationText="Mostrar mas resultados..."
								    />
								</div>
								
								<div className="col-xs-12 col-sm-2">
									<div className="col-xs-12" style={{textAlign:'center'}}>
										<span className="span-min">Fecha y Hora Inicio</span>
									</div>
									<div className="col-xs-12 col-sm-7">
										<input type="date" name="start_date" id="start_date" value={this.state.start_date}
											onChange={this.handleChange} className="form-control hour-input" required />
									</div>
									<div className="col-xs-12 col-sm-5">
										<input type="text" id="start_hour" name="start_hour"  
											data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
											data-inputmask-placeholder="-" value={this.state.start_hour || ""} 
											onChange={this.handleChange} style={{padding:"5px"}} 
											className="form-control" required/>
									</div>
								</div>
								<div className="col-xs-12 col-sm-2">
									<div className="col-xs-12" style={{textAlign:'center'}}>
										<span className="span-min">Fecha y Hora Termino</span>
									</div>
									<div className="col-xs-12 col-sm-7">
										<input type="date" name="end_date" id="end_date" value={this.state.end_date}
											onChange={this.handleChange} className="form-control hour-input" required/>
									</div>
									<div className="col-xs-12 col-sm-5">
										<input type="text" id="end_hour" name="end_hour"  
											data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
											data-inputmask-placeholder="-" value={this.state.end_hour || ""} 
											onChange={this.handleChange} style={{padding:"5px"}} required
											className="form-control"/>
									</div>
								</div>
							</div>
						</div>
					
						<div className="col-xs-12 col-sm-4 form-group">
							<span className="span-min">Observaciones</span>
							<textarea className="form-control" name="description" id="description" 
								value={this.state.description || ""} onChange={this.handleChange}
								style={{height:"7em",width:"100%",resize:"none"}}>
							</textarea>
						</div>
						<div className="col-xs-12 col-sm-4 form-group">
							<span className="span-min">Lista de Otros Recursos Humanos</span>
							<textarea className="form-control" name="human_resources" id="human_resources" 
								value={this.state.human_resources || ""} onChange={this.handleChange}
								style={{height:"7em",width:"100%",resize:"none"}}>
							</textarea>
						</div>
						{/*<div className="col-xs-12 col-sm-6 form-group">
							<span className="span-min">Lista de Recursos Materiales</span>
							<textarea className="form-control" name="material_resources" id="material_resources" 
								value={this.state.material_resources} onChange={this.handleChange}
								style={{height:"7em",width:"100%",resize:"none"}}>
							</textarea>
										</div>*/}
						<div className="col-xs-12 col-sm-4 form-group">
							<span className="span-min">Lista de Tareas</span>
							<textarea className="form-control" name="task_list" id="task_list" 
								value={this.state.task_list || ""} onChange={this.handleChange}
								style={{height:"7em",width:"100%",resize:"none"}}>
							</textarea>
						</div>
					</fieldset>

					<fieldset className="col-xs-12 col-sm-8">
						<legend>Personal de Contacto</legend>

						<div className="col-xs-12 col-sm-6" style={{padding:'0'}}> 
							<div className="person">
								<div className="col-xs-12 form-group" style={{padding:"0px"}}>
									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-6">
											<span className="span-min">Nombre</span>
											<input type="text" name="name" id="name" value={this.state.name} required
												onChange={this.handleChange} className="form-control" />
										</div>

										<div className="col-xs-12 col-sm-6">
											<span className="span-min">Apellidos</span>
											<input type="text" name="lastname1" id="lastname1" value={this.state.lastname1} required
											onChange={this.handleChange} className="form-control" />
										</div>										
									</div>
								</div>
							</div>
							<div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-6">
							            <span className="span-min">{t('content.generics.phones.type')}</span>
							            <select className="form-control" name="phone_type" id="phone_type" value={ this.state.phone_type || "" } disabled >
							                <option value="" disabled></option>
							                {this.state.phoneTypes.map(function(t) {
							                    return <option key={t.id}  value={t.key}>{t.name}</option>;
							                })}
							            </select>
							        </div>

							        <div className="col-xs-12 col-sm-6">
              							<span className="span-min">{t('content.offers.form.number')} </span>
							              <MaskedFormControl type='text' name="phone_number" id="phone_number" value={ this.state.phone_number } 
							                    onChange={ this.handleChange } mask='111-111-1111' className="form-control" 
							                    required={this.state.require_phone !== undefined ? this.state.require_phone : true} />
          							</div>

								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-1" style={{marginTop:'17px'}}>
										<button className="btn btn-info" onClick={this.savePerson}>
											Agregar
										</button>	
									</div>
								</div>
							</div>

							<div className="col-xs-12">
								<Table responsive hover>
									<thead>
										<tr>
											<th>Nombre</th>
											<th>Telefono</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{this.state.list_person.map((p, i)=>(
											<tr key={i}>
												<td>{p.name}</td>
												<td>{p.phone}</td>
												<td></td>
											</tr>
										))}
											
									</tbody>
								</Table>
							</div>
						</div>
						<div className="col-xs-12 col-sm-6">
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-9">
									<span className="span-min">Personal del Banco</span>
									<Typeahead
								        labelKey={(option) => `${option.names}`}
								        minLength={0}
								        maxLength={50}
								        name="person"
								        id="person"
								        options={this.state.medical_staff}
								        onChange={this.changeMedicalPersonal}
								        ref={ref => this._typeahead_medical = ref}
								        useCache={false}
								        defaultSelected={this.state.medical_staff.slice(this.state.index, 1)}
										selected={this.state.medical_person_selected}
										delay={600}
										paginationText="Mostrar mas resultados..."
								    />
								</div>
								<div className="col-xs-12 col-sm-1" style={{padding:'0', paddingLeft:'8px'}}>
									<FloatingActionButton className="action-btn" mini={true} 
										style={{marginTop: 20 }} onClick={this.addMedical} iconStyle={{height: 25, width: 25}}>
				                      <ContentAdd/>
				                    </FloatingActionButton> 
			                    </div>
							</div>

							<div className="col-xs-12">
								<Table responsive hover>
									
									<thead>
										<tr>
											<th>Titulo</th>
											<th>Nombre</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{this.state.medical_list.map((m, i)=>(
											<tr key={i}>
												<td>{m.title}</td>
												<td>{m.name}</td>
												<td>
													<button className="btn btn-info btn-xs" title="Eliminar" 
														style={{marginRight:'3px'}} 
														onClick={(e) =>  this.deleteMedical(e,i)}>
							                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
							                        </button>
												</td>
											</tr>
										))}
									</tbody>
									
								</Table>
							</div>
						</div>
					</fieldset>

					<fieldset className="col-xs-12 col-sm-4 ">
						<legend>Productos</legend>
						<div className="col-xs-12 form-group" style={{paddingLeft:'0', paddingRight:'0'}}>
							<div className="col-xs-12 col-sm-8">
								<span className="span-min">Productos</span>
								<select className="form-control" name="product" id="product" 
									value={this.state.product} onChange={this.handleChange}>
									<option value="">Seleccione</option>
									{this.state.products.map((p, i)=>(
										<option key={i} value={p.key}>
											{p.name}
										</option>
									))}
								</select>
							</div>
							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Cantidad</span>
								<input type="number" className="form-control hour-input" name="amount" id="amount"
									value={this.state.amount} onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-1" style={{padding:'0', paddingLeft:'8px'}}>
								<FloatingActionButton className="action-btn" mini={true} 
									style={{marginTop: 20 }} onClick={this.addProduct} iconStyle={{height: 25, width: 25}}>
			                      <ContentAdd/>
			                    </FloatingActionButton> 
		                    </div>
						</div>
						<div className="col-xs-12">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Producto</th>
										<th>Cantidad</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.campaign_has_products.map((p,i)=>(
										<tr key={i}>
											<td>{p.product}</td>
											<td>{p.amount}</td>
											<td>
												<button className="btn btn-info btn-xs" title="Eliminar" 
													style={{marginRight:'3px'}} 
													onClick={(e) =>  this.deleteProduct(e,i)}>
						                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
						                        </button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>
					</fieldset>

		        	<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} 
		        			primary={true} onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} 
		        			primary={true} style={{margin:12}} onClick={this.onReturn}/>
		        	</div>
				</div>

				<ModalPlaces {...this.props} onRef={ref => this.modal_places = ref}
					getConvokePlace={this.getConvokePlace} />
			</div>
		)
	}
}

export default translate('translations')(RegisterCampaign);